import { MultiLevelNavigation } from '@components/Base/MultiLevelNavigation/MultiLevelNavigation'
import { IMultiLevelMenu } from '@interfaces/interfaces'
import { Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'

export type INavigation = {
  headerMenuItems: IMultiLevelMenu[]
  highlightActive?: boolean
  paddingHorizontal?: number | string
}

export const Navigation: React.FC<INavigation> = ({
  headerMenuItems,
  highlightActive,
  paddingHorizontal,
}) => {
  const [horozontalPading, setHorizontalPadding] = useState<number | string>(4)
  useEffect(() => {
    if (!paddingHorizontal && paddingHorizontal !== 0) setHorizontalPadding(4)
    if (paddingHorizontal === 0) setHorizontalPadding(0)
    if (paddingHorizontal) setHorizontalPadding(paddingHorizontal)
  }, [paddingHorizontal])
  return (
    <Stack direction='row' gap={8} px={horozontalPading} component={'nav'}>
      {headerMenuItems.map((item, index) => (
        <MultiLevelNavigation
          key={index}
          multiLevelMenu={item}
          highlightActive={highlightActive}
        />
      ))}
    </Stack>
  )
}
